/* unplugin-vue-components disabled */import script from "./International_3.vue?vue&type=script&setup=true&lang=ts"
export * from "./International_3.vue?vue&type=script&setup=true&lang=ts"

import "./International_3.vue?vue&type=style&index=0&id=ffe5ced6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffe5ced6"]])

export default __exports__